import PropTypes from "prop-types";
import R from "ramda";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.number,
    uid: PropTypes.string,
    token: PropTypes.string,
    identityProviderName: PropTypes.string,
  },
  {
    facebookIdentity(identities) {
      if (R.isNil(identities)) {
        return null;
      }

      const fbIdentities = identities.filter((i) => i.identityProviderName === "facebook");
      return fbIdentities.length ? R.last(fbIdentities) : null;
    },
  },
);
